import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel } from '../../shared';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})

export class ProductionMasterScheduleService extends BaseApiTemplateService<any> {

  customUrl;
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mrp/production-master-schedule';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'mrp/production-master-schedule';
    this.httpClient = http;
  }

  async generateReport(authorization: string, apiVisa: ApiVisa) {
    const CSV_URL = apiVisa.api_domain_url + this.endpoint_path + '/generate-report/backoffice-ep';
    const headers = new HttpHeaders({ "authorization": authorization, "tenantCode": apiVisa.tenantCode });
    const fileBlob = await this.httpClient
      .get(CSV_URL, { headers, responseType: 'blob' })
      .toPromise();
    return fileBlob;
  }



}